import { Button } from '@mgrvtechgroup/admin-ds';

/** 사진이 많은 화면에서 처음 보여 주는 장수 — 3열 기준 두 줄. */
export const PHOTO_PREVIEW_LIMIT = 6;

/**
 * 앞쪽 몇 장만 먼저 보이고 나머지는 눌러서 펼친다(DS C12 점진적 공개) — 사진이 수십 장이면
 * 한 화면의 대부분을 사진이 차지해 그 아래 내용에 닿기 어렵다. 한도 이하이거나 이미 펼쳤으면
 * 아무것도 그리지 않는다(다시 접지 않는다 — 새로고침·재방문하면 접힌 채로 시작한다).
 * 접근 가능한 이름은 어느 사진 묶음인지 포함한다(한 화면에 같은 버튼이 여러 개일 수 있다).
 */
export function PhotoToggle({
  subject,
  total,
  expanded,
  onExpand,
  limit = PHOTO_PREVIEW_LIMIT,
}: {
  subject: string;
  total: number;
  expanded: boolean;
  onExpand: () => void;
  limit?: number;
}) {
  if (expanded || total <= limit) return null;
  const label = '더 보기';
  return (
    <div>
      <Button
        size="sm"
        variant="outline"
        aria-expanded={false}
        aria-label={`${subject} ${label}`}
        onClick={onExpand}
      >
        {label}
      </Button>
    </div>
  );
}
